import api from 'services/api';
import { UpdateApplicationFormPaylod } from './actions';

export async function updateApplicationForm({
  applicationFormInfo,
  organizationId,
}: {
  applicationFormInfo: UpdateApplicationFormPaylod;
  organizationId: string;
}) {
  const response = api.put(
    `api/dashboard/organizations/${organizationId}/application_forms/${applicationFormInfo.id}`,
    {
      application_form: {
        phone_number: applicationFormInfo.phone_number,
        education: applicationFormInfo.education,
        experience: applicationFormInfo.experience,
        summary: applicationFormInfo.summary,
        resume: applicationFormInfo.summary,
        cover_letter: applicationFormInfo.cover_letter,
        application_form_details_attributes: applicationFormInfo.application_form_details,
      },
    },
  );
  return response;
}
